import React, {PropTypes} from 'react';
import { Grid, Row, Col, Button, Image } from 'react-bootstrap';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// LOCAL
import ProfileForm from './ProfileForm'
// SHARED
import muiTheme from '../utils/muiTheme'

export default class ProfileTab extends React.Component {
  state = {
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone_number": "",
    "company_name": "",
    "description": "",
    "preview_url": ""
  }
  handleSubmit = (values) => {

    this.setState(Object.assign({}, this.state, values));

    const {onProfileFormSave, groupAsAccountant} = this.props

    var newProfile = (groupAsAccountant && !groupAsAccountant.first_name)

    // Remove null values
    var filteredValues = {}
    for (var prop in values) {
      if (values[prop] != null && values[prop] != "null") {
        console.log('values.' + prop, '=', values[prop]);
        filteredValues[prop] = values[prop]
      }
    }

    onProfileFormSave(filteredValues, newProfile)
  }

  handleChange = (e) => {

    var newState = {}
    if (e.target) {
      newState[e.target.name] = e.target.value
      this.setState(Object.assign({}, this.state, newState));
    }

  }

  handleChangeFile = (file) => {
    console.log("file");
    console.log(file);

    var newState = {}
    newState["preview_url"] = file.preview
    this.setState(Object.assign({}, this.state, newState));
  }

  render() {

    const {groupAsAccountant, ui, onAccountantGroupFormReset} = this.props

    var profileImageURL = (groupAsAccountant && groupAsAccountant.photo && groupAsAccountant.photo.image_url) ? groupAsAccountant.photo.image_url : "https://s3.amazonaws.com/everlance-dashboard/assets/images/Gender+Neutral+User+Filled-100-666666.png"

    profileImageURL = this.state.preview_url ? this.state.preview_url : profileImageURL

    return (<div className="tab-content profile-tab">

      <Grid fluid={true}>
        <Row className="show-grid">
          <Col xs={12} sm={12} md={7}>
            <h3 className="column-title">Accountant Profile</h3>
            <p className="column-title-subcopy">Show your profile in your clients' Everlance app.</p>
          </Col>
          <Col className="min-width-992" xs={12} sm={12} md={5}>
            <h3 className="column-title">Client App Preview</h3>
            <p className="column-title-subcopy">How your info will look in your clients' app:</p>

          </Col>
        </Row>

        <Row className="show-grid">
          <Col xs={12} sm={12} md={7}>
            <MuiThemeProvider muiTheme={muiTheme}>
              <ProfileForm
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
                onChangeFile={this.handleChangeFile}
                accountantGroupForm={ui.accountantGroupForm}
                onAccountantGroupFormReset={onAccountantGroupFormReset}
              />
            </MuiThemeProvider>


          </Col>
          <Col className="max-width-768" xs={12} sm={12} md={5}>
            <h3 className="column-title">Client App Preview</h3>
            <p className="column-title-subcopy">This is a preview of how your profile will look inside your client's Everlance app.</p>

          </Col>
          <Col className="app-profile-preview" xs={12} sm={12} md={5}>
            <div className="app-preview-content-wrapper">
              <Row className="show-grid info-header">
                <Col className="info-header-image-wrapper" xs={4} sm={4} md={4}>
                  <Image src={profileImageURL} rounded />
                </Col>
                <Col xs={8} sm={8} md={8}>
                  <p>{this.state.first_name || (groupAsAccountant && groupAsAccountant.first_name)} {this.state.last_name || (groupAsAccountant && groupAsAccountant.last_name)}</p>
                  <p className="company-name-text">{this.state.company_name || (groupAsAccountant && groupAsAccountant.company_name)}</p>
                </Col>
              </Row>
              <Row className="show-grid">
                <Col xs={12} sm={12} md={12}>
                  <hr />
                </Col>
              </Row>
              <Row className="show-grid info-body">
                <Col xs={12} sm={12} md={12}>
                    <Row className="show-grid">
                      <Col xs={2} sm={2} md={2}>
                        <Image src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Message-100-31b59f.png" rounded />
                      </Col>
                      <Col xs={9} sm={9} md={9}>
                        {this.state.email || (groupAsAccountant && groupAsAccountant.email)}
                      </Col>
                    </Row>
                    <Row className="show-grid">
                      <Col xs={2} sm={2} md={2}>
                        <Image src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Phone-100-31b59f.png" rounded />
                      </Col>
                      <Col xs={9} sm={9} md={9}>
                        {this.state.phone_number || (groupAsAccountant && groupAsAccountant.phone_number)}
                      </Col>
                    </Row>
                    <Row className="show-grid">
                      <Col xs={2} sm={2} md={2}>
                        <Image src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Information-100-31b59f.png" rounded />
                      </Col>
                      <Col xs={9} sm={9} md={9}>
                        {this.state.description || (groupAsAccountant && groupAsAccountant.description)}
                      </Col>
                    </Row>

                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>

    </div>);
  }
}

ProfileTab.propTypes = {
};



// WEBPACK FOOTER //
// ./src/accountants/ProfileTab.js